import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { Button } from "@core/components/ui/Button";
import { Drawer, DrawerTitle, DrawerTrigger, DrawerContent, DrawerClose } from "@core/components/ui/Drawer";
import Logo from "@core/layouts/header/components/common/Logo";
import MenuLink from "@core/components/link/MenuLink";
import { useCnbConfig } from "@core/hooks/useCnbConfig";
import { cn } from "@core/utils/domUtil";
import { X } from "lucide-react";

export default function DrawerMenuMobile() {
  const [isOpen, setIsOpen] = useState(false);
  const { data, activeIndex } = useCnbConfig();
  const location = useLocation();

  // 페이지 변경 시 메뉴 닫기
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <Drawer direction="left" open={isOpen} onOpenChange={setIsOpen} handleOnly={true}>
      <DrawerTrigger asChild>
        <Button variant="text" className={cn("flex h-[36px] w-[36px] items-center justify-center p-0!")}>
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 2.25H0V0.75H18V2.25Z" fill="#0F172A" />
            <path d="M18 7.75H0V6.25H18V7.75Z" fill="#0F172A" />
            <path d="M0 13.25H18V11.75H0V13.25Z" fill="#0F172A" />
          </svg>
        </Button>
      </DrawerTrigger>
      <DrawerContent className={cn("w-[300px]!")} aria-describedby={undefined}>
        {/* 타이틀 - 접근성 준수를 위해 추가 및 숨김 처리 */}
        <DrawerTitle className="hidden">CNB</DrawerTitle>
        <div className="flex items-center justify-between px-[20px] py-[15px]">
          <DrawerClose asChild>
            <Button variant="text" className={cn("flex h-[36px] w-[36px] shrink-0 items-center justify-center p-0!")}>
              <X className="size-[32px]" />
            </Button>
          </DrawerClose>
          <Logo className="w-full text-center" />
        </div>
        <div className="overflow-y-auto pb-[15px]">
          {Array.isArray(data?.menu) && data?.menu?.length > 0 && (
            <ul className="px-[30px]">
              {data?.menu?.map((item, itemIdx) => (
                <li key={item.name} className="mt-[15px]">
                  <MenuLink url={item?.url} name={item?.name} className={cn("block py-[10px] text-[18px] font-bold", itemIdx === activeIndex?.[0] && "text-point-600")} />
                  {Array.isArray(item?.children) && item?.children?.length > 0 && (
                    <ul>
                      {item?.children?.map((child, childIdx) => (
                        <li key={child.name}>
                          <MenuLink
                            url={child?.url}
                            name={child?.name}
                            className={cn("text-lg leading-[30px]", itemIdx === activeIndex?.[0] && childIdx === activeIndex?.[1] && "text-point-600 font-bold")}
                          />
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
